import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** GET DEMAND COLLECTION LIST START *********************** */
export const DemandCollectionListGet = (listData: any, urlName: any) => {
	const data = {
		DemandCollectionReportToken: listData,
	};
	const url = `${API_URL}${urlName}`;
	return makeApiCall(url, data);
};
/** ***************** GET DEMAND COLLECTION LIST END *********************** */
